<template>
    <card class="spaced typo" v-show="loaded">

        <div class="pt-2" v-if="ctrl.rows.length || search">

            <h2 class="text-white mb-4">{{ $t('common.roles') }}</h2>

            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <base-table :data="ctrl.rows" :columns="columns">

                <template slot="columns">
                    <th>{{ $t('common.name') }}</th>
                    <th>{{ $t('common.permissions') }}</th>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <td>
                        {{ row.name }}
                    </td>
                    <td>
                        <span v-for="(permissionGroup, groupKey) in permissions" :key="groupKey">
                            <span v-for="(permission, key) in permissionGroup.permissions" :key="key">
                                <badge type="default"
                                    class="mr-1"
                                    v-if="row.permissions[key]">
                                    {{ permission.name }}
                                </badge>
                            </span>
                        </span>
                    </td>
                    <td class="td-actions text-right">

                        <base-button icon link size="md" type="warning" @click="ctrl.update(row.id)">
                            <i class="tim-icons icon-pencil"></i>
                        </base-button>

                        <base-button icon link size="md" type="danger" @click="ctrl.delete(row.id)">
                            <i class="tim-icons icon-simple-remove"></i>
                        </base-button>

                    </td>
                </template>

            </base-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <p class="text-center py-3" v-else>{{ $t('roles.no-role') }}</p>
                
        <div class="text-center">
            <base-button type="primary" @click="ctrl.create()">
                {{ $t('roles.new') }}
            </base-button>
        </div>

        <portal to="modals">

            <modal class="no-footer" :title="$t('common.role')" v-model="ctrl.modals.edit" :loading="ctrl.form.loading">
                <role-form v-model="ctrl.form.data" :errors="ctrl.form.errors" :permissions="permissions"></role-form>
            </modal>

            <modal-confirm v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('roles.delete-confirm') }}</p>
            </modal-confirm>

        </portal>
    </card>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import RoleForm from './RoleForm'

    export default {

        components: {
            RoleForm
        },

        data() {
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/trax/api/front/roles',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    paging: {
                        perPage: 10,
                        perPageOptions: [5, 10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: ['name'],
                        include: ['permissions'],
                        filters: { owner_id: this.$auth.owner.id }
                    }
                }),
                search: '',
                columns: ['name', 'permissions'],
                permissions: {},
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.permissions = resp.data.included.permissions
            })
        },

        watch: {
            search(val) {
                this.ctrl.filter({
                    name: {$text: val},
                    owner_id: this.$auth.owner.id,
                })
            }
        },

        methods: {
            
            mapData(role) {
                return {
                    id: role ? role.id : null,
                    name: role ? role.name : null,
                    permissions: role && !Array.isArray(role.permissions) ? role.permissions : {},
                }
            },

            unmapData(data) {
                let role = {...data}
                role.owner_id = this.$auth.owner.id
                return role
            }
        }
    }
</script>
